import React, { useCallback, useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Button } from "reactstrap"
import { FilterData, IndexType } from "components/Extra"
import ProductsTable from "pages/admin/Products/ProductsTable"
import { ProductCards } from "pages/admin/Products/ProductsCards"
import { ProductsGrid } from "pages/admin/Products/ProductsGrid"
import { AddNewProduct } from "pages/admin/Products/Modals"
import { useNavigate, useSearchParams } from "react-router-dom"
import { AddNewOffer } from "pages/admin/Offers/Modals/AddNewOffer/AddNewOffer"
import { AddNewCampaign } from "pages/admin/Campaigns/Modals/AddNewCampaign"
import { useTranslation } from "react-i18next"

export interface Product {
  id: string
  name: string
  category: string
  couponBased: boolean
  price: string
  size: string
  stock: number
  featured: boolean
  status: "Active" | "In Active"
}

export const productsData: Product[] = [
  {
    id: "ID-145871",
    name: "Product A",
    category: "Category AB",
    couponBased: true,
    price: "QAR 20,00",
    size: "400ml",
    stock: 20,
    featured: true,
    status: "Active",
  },
  {
    id: "ID-145872",
    name: "Product BC",
    category: "Category CB",
    couponBased: true,
    price: "QAR 20,00",
    size: "Gallon",
    stock: 60,
    featured: false,
    status: "In Active",
  },
  {
    id: "ID-145873",
    name: "Product BC",
    category: "Category CB",
    couponBased: true,
    price: "QAR 20,00",
    size: "Gallon",
    stock: 20,
    featured: true,
    status: "In Active",
  },
  {
    id: "ID-145874",
    name: "Product ZBC",
    category: "Category AAB",
    couponBased: false,
    price: "QAR 20,00",
    size: "400ml",
    stock: 60,
    featured: false,
    status: "Active",
  },
  {
    id: "ID-145875",
    name: "Product BC",
    category: "Category CB",
    couponBased: true,
    price: "QAR 20,00",
    size: "Gallon",
    stock: 20,
    featured: true,
    status: "In Active",
  },
  {
    id: "ID-145876",
    name: "Product BC",
    category: "Category AB",
    couponBased: true,
    price: "QAR 20,00",
    size: "Gallon",
    stock: 20,
    featured: true,
    status: "Active",
  },
  {
    id: "ID-145877",
    name: "Product BC",
    category: "Category AB",
    couponBased: true,
    price: "QAR 20,00",
    size: "Gallon",
    stock: 20,
    featured: true,
    status: "Active",
  },
]

interface ProductsProps {
  isDashboardPage?: boolean
}

export const Products: React.FC<ProductsProps> = ({ isDashboardPage }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()

  const [activeTab, setActiveTab] = useState<IndexType>("list-ul")
  const [checkedProducts, setCheckedProducts] = useState<Product[]>([])
  const [products, setProducts] = useState<Product[]>([])
  const [filteredProducts, setFilteredProducts] = useState<Product[]>([])
  const [showAddNewProduct, setShowAddNewProduct] = useState(false)
  const [openAddNewOfferModal, setOpenAddNewOfferModal] =
    useState<boolean>(false)
  const [openAddNewCompaignModal, setOpenAddNewCompaignModal] =
    useState<boolean>(false)
  const [duplicateProductData, setDuplicateProductData] = useState<any>(null)

  const isAllChecked = useMemo(() => {
    return products.length > 0 && checkedProducts.length === products.length
  }, [products, checkedProducts])

  const togglecheckedProductHandler = useCallback((product: Product) => {
    setCheckedProducts(prev =>
      prev.includes(product)
        ? prev.filter(p => p !== product)
        : [...prev, product]
    )
  }, [])

  const toggleAllProducts = useCallback(() => {
    setCheckedProducts(isAllChecked ? [] : products)
  }, [isAllChecked, products])

  const toggleActiveProduct = useCallback(
    (product: Product) => {
      setProducts(prev =>
        prev.map(p =>
          p.id === product.id
            ? {
                ...p,
                status: p.status === "Active" ? "In Active" : "Active",
              }
            : p
        )
      )
    },
    [products]
  )

    useEffect(() => {
      setProducts(productsData)
      setFilteredProducts(productsData)
    }, [])

  useEffect(() => {
    const tabParam = searchParams.get("lowStockAlert")
    if (tabParam) {
      const lowStockProducts = productsData.sort((a, b) => a.stock - b.stock).slice(0, Number(tabParam));
      setProducts(lowStockProducts);
      setFilteredProducts(lowStockProducts);
    } else{
      setProducts(productsData)
      setFilteredProducts(productsData)
    }
  }, [])
  

  const addNewProductHandler = useCallback(() => {
    setDuplicateProductData(null) // Clear any existing duplicate data
    setShowAddNewProduct(true)
  }, [])
  const editProductHandler = useCallback((product: Product) => {}, [])
  const deleteProductHandler = useCallback((product: Product) => {}, [])
  const viewDetailsHandler = useCallback((product: Product) => {
    navigate(`/products/${product.id}`)
  }, [])

  const addNewOffer = useCallback((product: Product) => {
    setOpenAddNewOfferModal(true)
  }, [])
  const addNewCampaign = useCallback((product: Product) => {
    setOpenAddNewCompaignModal(true)
  }, [])
  const duplicateProductHandler = useCallback((product: Product) => {
    const initialValues = {
      productName: product.name ,
      category: {
        id: product.category.toLowerCase().replace(/\s+/g, '-'),
        name: product.category
      },
      price: parseFloat(product.price.replace(/[^\d.]/g, '')),
      brand: "",
      productImage: null,
      latestTag: "",
      tags: [],
      barcode: null,
      stockQuantity: {
        id: product.stock.toString(),
        name: product.stock.toString()
      },
      lowStock: 0,
      phLevel: 0,
      soudiumLevel: 0,
      composition: [
        {
          name: "",
          value: 0,
        }
      ],
      productDescription: "",
      automaticCouponGeneration: product.couponBased,
      ProductVisibility: true,
      pinProductVisibility: product.featured,
      couponBasedProduct: product.couponBased,
    }

    setDuplicateProductData(initialValues)
    setShowAddNewProduct(true)
  }, [])

  if (isDashboardPage) {
    return (
      <>
        <FilterData
          data={products}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          bearerFilteredData={setFilteredProducts}
          showFilterBtnInsteadOfToggle
        />

        {/* Modals */}
        <AddNewProduct
          isOpen={showAddNewProduct}
          toggle={() => {
            setShowAddNewProduct(false)
            setDuplicateProductData(null)
          }}
          initialValues={duplicateProductData}
        />

        <AddNewOffer
          formSubmitedHandler={() => {}}
          isOpen={openAddNewOfferModal}
          toggle={() => setOpenAddNewOfferModal(false)}
        />

        <AddNewCampaign
          isOpen={openAddNewCompaignModal}
          toggle={() => setOpenAddNewCompaignModal(false)}
        />
        <ProductsTable
          products={filteredProducts}
          isAllChecked={isAllChecked}
          checkedProducts={checkedProducts}
          toggleAllProducts={toggleAllProducts}
          togglecheckedProductHandler={togglecheckedProductHandler}
          toggleActiveProduct={toggleActiveProduct}
          editProductHandler={editProductHandler}
          deleteProductHandler={deleteProductHandler}
          viewDetailsHandler={viewDetailsHandler}
        />
      </>
    )
  }

  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("products_products")}
        />
        <Button
          onClick={addNewProductHandler}
          className="bg-gradiant-blue text-capitalize"
        >
          {t("products_addNewProduct")}
        </Button>
      </div>
      <ProductCards />
      <FilterData
        data={products}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        bearerFilteredData={setFilteredProducts}
        showSearchFilterBtn
      />

      {/* Modals */}
      <AddNewProduct
        isOpen={showAddNewProduct}
        toggle={() => {
          setShowAddNewProduct(false)
          setDuplicateProductData(null)
        }}
        initialValues={duplicateProductData}
      />

      <AddNewOffer
        formSubmitedHandler={() => {}}
        isOpen={openAddNewOfferModal}
        toggle={() => setOpenAddNewOfferModal(false)}
      />

      <AddNewCampaign
        isOpen={openAddNewCompaignModal}
        toggle={() => setOpenAddNewCompaignModal(false)}
      />

      {activeTab == "list-ul" ? (
        <ProductsTable
          products={filteredProducts}
          isAllChecked={isAllChecked}
          checkedProducts={checkedProducts}
          toggleAllProducts={toggleAllProducts}
          togglecheckedProductHandler={togglecheckedProductHandler}
          toggleActiveProduct={toggleActiveProduct}
          editProductHandler={editProductHandler}
          deleteProductHandler={deleteProductHandler}
          viewDetailsHandler={viewDetailsHandler}
          addNewOffer={addNewOffer}
          addNewCampaign={addNewCampaign}
          duplicateProductHandler={duplicateProductHandler}
        />
      ) : (
        <ProductsGrid
          products={filteredProducts}
          editProductHandler={editProductHandler}
          deleteProductHandler={deleteProductHandler}
          viewDetailsHandler={viewDetailsHandler}
          toggleActiveProduct={toggleActiveProduct}
          addNewOffer={addNewOffer}
          addNewCampaign={addNewCampaign}
          duplicateProductHandler={duplicateProductHandler}
        />
      )}
    </div>
  )
}
